import { createSlice } from '@reduxjs/toolkit'

const devicesInit = [
  { id: 'native', name: 'Device Camera', type: 'camera' },
  { id: 'upload', name: 'Device Upload', type: 'camera' },
  { id: 'noscale', name: 'No Scale', type: 'scale' },
]

const initialState = {
  devices: devicesInit,
  selectedCameraId: undefined,
  selectedScaleIds: [],
  selectedCameraIds: [],
  scaleCameras: {},
}

//scaleCameras is an object with the scale id as the key and an array of camera ids as the value
// {
//   "gsGateway-dev-100004:30001": [
//       "gsGateway-dev-100004:40002",
//       "gsGateway-dev-100004:40004"
//   ],
//   "gsGateway-dev-100004:30002": []
// }

export const deviceSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    // Redux Toolkit allows us to write "mutating" logic in reducers. It
    // doesn't actually mutate the state because it uses the Immer library,
    // which detects changes to a "draft state" and produces a brand new
    // immutable state based off those changes
    updateDeviceList: (state, action) => {
      state.devices = [...devicesInit, ...action.payload]
    },
    selectCamera: (state, action) => {
      state.selectedCameraId = action.payload
    },
    selectScales: (state, action) => {
      state.selectedScaleIds = action.payload
    },
    selectCameras: (state, action) => {
      state.selectedCameraIds = action.payload
    },
    selectScaleCameras: (state, action) => {
      state.scaleCameras = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { updateDeviceList, selectCamera, selectScales, selectCameras, selectScaleCameras } = deviceSlice.actions

export const getSelectedCamera = state => state.devices.find(d => d.id === state.selectedCameraId)
export const getSelectedScale = state => state.devices.find(d => state.selectedScaleIds?.indexOf(d.id) > -1)

export default deviceSlice.reducer
